var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 496,
    viewBox: "0 0 1200 496",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 426.075,
    rx: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_2887",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1200,
    height: 496
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 496,
    rx: 30,
    fill: "#762AD6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_2887)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2_2887)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.132,
    cy: 230.456,
    rx: 292.132,
    ry: 230.456,
    transform: "matrix(1 0 0 -1 588.896 475.141)",
    fill: "#AAEBFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 338.555,
    cy: 267.227,
    rx: 338.555,
    ry: 267.227,
    transform: "matrix(1 0 0 -1 573.892 602.565)",
    fill: "#C1BCFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 338.555,
    cy: 267.227,
    rx: 338.555,
    ry: 267.227,
    transform: "matrix(1 0 0 -1 -197 540.673)",
    fill: "#C1BCFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 263.529,
    cy: 207.884,
    rx: 263.529,
    ry: 207.884,
    transform: "matrix(1 0 0 -1 -164.178 469.316)",
    fill: "#FFD9DD"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 263.529,
    cy: 207.884,
    rx: 263.529,
    ry: 207.884,
    transform: "matrix(1 0 0 -1 194.072 473.684)",
    fill: "#DEB5FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.083,
    cy: 189.316,
    rx: 240.083,
    ry: 189.316,
    transform: "matrix(1 0 0 -1 -10.375 257.426)",
    fill: "#C173FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.083,
    cy: 189.316,
    rx: 240.083,
    ry: 189.316,
    transform: "matrix(1 0 0 -1 149.992 335.337)",
    fill: "#C173FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.2176,
    cy: 46.2369,
    rx: 87.2176,
    ry: 46.2369,
    transform: "matrix(1 0 0 -1 41.207 290.921)",
    fill: "#FFDA58"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.2176,
    cy: 46.2369,
    rx: 87.2176,
    ry: 46.2369,
    transform: "matrix(1 0 0 -1 41.207 308.396)",
    fill: "#FFDD65"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2_2887",
    x: -480.591,
    y: -404.797,
    width: 2015.18,
    height: 1290.95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 141.795,
    result: "effect1_foregroundBlur_2_2887"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground1);
export default __webpack_public_path__ + "static/media/background1.d1768c60ac4513557bdfd7cad6a9a68b.svg";
export { ForwardRef as ReactComponent };